import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Courses.css";
import InquiryFormModal from "../components/InquiryFormModal";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isTableView, setIsTableView] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    image: null,
  });

  const [updateData, setUpdateData] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axios.get("/api/v1/courses/courses");
      setCourses(res.data.data.courses);
      setLoading(false);
    } catch {
      setError("Failed to fetch courses");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));

    try {
      if (updateData) {
        await axios.put(
          `/api/v1/courses/admin/updatecourses/${updateData._id}`,
          data,
          { headers: { "x-auth-token": localStorage.getItem("token") } }
        );
        setMessage("Course updated successfully!");
      } else {
        await axios.post("/api/v1/courses/createcourse", data, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        });
        setMessage("Course created successfully!");
      }

      setFormData({ title: "", description: "", price: "", image: null });
      setUpdateData(null);
      fetchCourses();
    } catch {
      setMessage("Operation failed");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/v1/courses/admin/deletecourses/${id}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      });
      fetchCourses();
    } catch {
      setError("Delete failed");
    }
  };

  const handleEdit = (course) => {
    setUpdateData(course);
    setFormData(course);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="courses-container">
      <h2>{updateData ? "Update Course" : "Create Course"}</h2>

      <form className="course-form" onSubmit={handleSubmit}>
        <input
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="price"
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
          required
        />
        <input type="file" name="image" onChange={handleChange} />
        <button type="submit" className="btn-primary">
          {updateData ? "Update" : "Create"}
        </button>
        {message && <p className="success">{message}</p>}
      </form>

      <div className="view-toggle">
        <button onClick={() => setIsTableView(!isTableView)}>
          {isTableView ? "Grid View" : "Table View"}
        </button>
      </div>

      {isTableView ? (
        <table className="courses-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((c) => (
              <tr key={c._id}>
                <td>
                  <img src={`/${c.image}`} alt="" />
                </td>
                <td>{c.title}</td>
                <td>{c.price}</td>
                <td className="actions">
                  <button onClick={() => handleEdit(c)}>Edit</button>
                  <button
                    className="danger"
                    onClick={() => handleDelete(c._id)}
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCourse(c);
                      setIsModalVisible(true);
                    }}
                  >
                    Inquiry
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="courses-grid">
          {courses.map((c) => (
            <div key={c._id} className="course-card">
              <img src={`/${c.image}`} alt="" />
              <h3>{c.title}</h3>
              <p>{c.description}</p>
              <p>₹ {c.price}</p>
              <div className="card-actions">
                <button onClick={() => handleEdit(c)}>Edit</button>
                <button className="danger" onClick={() => handleDelete(c._id)}>
                  Delete
                </button>
                <button
                  onClick={() => {
                    setSelectedCourse(c);
                    setIsModalVisible(true);
                  }}
                >
                  Inquiry
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <InquiryFormModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        courseTitle={selectedCourse?.title}
      />
    </div>
  );
};

export default Courses;
